import { createStore } from 'vuex';
import Notifications from '@/store/common/Notifications';
// API
import Tracking from '@/store/API/Tracking';

export default createStore({
  modules: {
    Tracking,
    Notifications,
  }
});